export default __webpack_public_path__ + "static/media/dsoft-logo.392ca44c.svg";